import Modal from 'bootstrap/js/dist/modal';

const videoModalSelector = '.js-video-modal';
const removeWwwPrefix = (hostname) => hostname.replace(/^www\./, '');
const getFirstPathSegment = (pathname) => pathname.split('/').find(Boolean) || '';
const getLastPathSegment = (pathname) => pathname.split('/').findLast(Boolean) || '';

const getYouTubeEmbedUrl = (url) => {
    const host = removeWwwPrefix(url.hostname);

    if (host === 'youtu.be') {
        const videoId = getFirstPathSegment(url.pathname);
        return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
        const videoId = url.searchParams.get('v');
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
        }

        const pathParts = url.pathname.split('/').filter(Boolean);
        const isEmbedOrShortsUrl = pathParts[0] === 'embed' || pathParts[0] === 'shorts';

        if (isEmbedOrShortsUrl) {
            return pathParts[1] ? `https://www.youtube.com/embed/${pathParts[1]}` : '';
        }
    }

    return '';
};

const getVimeoEmbedUrl = (url) => {
    const videoId = getLastPathSegment(url.pathname);
    return videoId ? `https://player.vimeo.com/video/${videoId}` : '';
};

const getEmbedUrl = (rawUrl) => {
    if (!rawUrl) {
        return '';
    }

    try {
        const url = new URL(rawUrl, window.location.href);
        const host = removeWwwPrefix(url.hostname);

        if (host === 'youtu.be' || host === 'youtube.com' || host === 'm.youtube.com') {
            return getYouTubeEmbedUrl(url) || rawUrl;
        }

        if (host === 'vimeo.com' || host === 'player.vimeo.com') {
            return getVimeoEmbedUrl(url) || rawUrl;
        }
    } catch {
        return rawUrl;
    }

    return rawUrl;
};

const withAutoplay = (url) => {
    if (!url) {
        return '';
    }

    if (url.includes('autoplay=1')) {
        return url;
    }

    return url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;
};

document.querySelectorAll(videoModalSelector).forEach((modalEl) => {
    Modal.getOrCreateInstance(modalEl);

    modalEl.addEventListener('show.bs.modal', (event) => {
        const trigger = event.relatedTarget;
        if (!trigger) {
            return;
        }

        const rawUrl =
            trigger.dataset.videoSrc ||
            trigger.dataset.mfpSrc ||
            trigger.getAttribute('href');

        const container = trigger.parentElement;
        const videoTitle = container?.querySelector('.video-title')?.textContent?.trim() || '';

        if (!rawUrl) {
            return;
        }

        const iframe = modalEl.querySelector('.video-modal-iframe');
        if (!iframe) {
            return;
        }

        const embedUrl = getEmbedUrl(rawUrl);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'video_popup_opened',
            video_url: embedUrl,
            video_title: videoTitle
        });

        iframe.setAttribute('src', withAutoplay(embedUrl));
    });

    modalEl.addEventListener('hidden.bs.modal', () => {
        const iframe = modalEl.querySelector('.video-modal-iframe');
        if (iframe) {
            iframe.setAttribute('src', '');
        }
    });
});
